import ru from './ru.js'

const locale = JSON.parse(JSON.stringify(ru));

function setValue(obj, value) {
    for(let key in obj) {
        const val = obj[key];
        if(typeof val == "object") setValue(val, value);
        else obj[key] = value;
    }
}

setValue(locale, "ua")

export default locale;